import type { Component, Entity2D } from '../../odie';

import { ZombieBlockProps } from '../defs/block';
import { ZombieBlockView } from '../views/blocks/ZombieBlockView';

export type BasicBlockComponentOptions = {
  props: ZombieBlockProps;
};

export class ZombieBlockComponent implements Component {
  // constants
  //-------------------------------------------------------------------------
  public static readonly NAME = 'blockZombie';

  // fields
  //-------------------------------------------------------------------------
  // injected
  public entity!: Entity2D;
  // scene
  public view!: ZombieBlockView;

  // impl
  //-------------------------------------------------------------------------
  public init(options: BasicBlockComponentOptions): void {
    this.view = new ZombieBlockView(options.props);
  }
}
